import {
  ConnectNowCTACard,
  SelfCareSelfServiceCTACard,
  SingleStopServiceCTACard,
  TogetherAllCTACard,
} from '../../pages/recommendation/components/SelfServiceOptions';
import { Heading, Layout, Text } from '../core';
import { HeadingLevel, incrementHeadingLevel } from '../core/Heading';

export type SelfServiceCardsProps = {
  showConnectNow: boolean;
  showSelfCare: boolean;
  showTogetherall: boolean;
  headingLevel?: HeadingLevel;
  //   showSingleStop: boolean; // currently unused, as the SingleStop card makes its own query
};

export const SelfServiceCards = ({
  showConnectNow,
  showSelfCare,
  showTogetherall,
  headingLevel = 3,
  //   showSingleStop // currently unused, as the SingleStop card makes its own query
}: SelfServiceCardsProps): JSX.Element => {
  return (
    <Layout.VStack space={4}>
      <Layout.VStack space={2}>
        <Heading.h3 level={headingLevel}>Additional self-serve tools</Heading.h3>

        <Text.paraSmall>
          Access the following tools at any time from within the Mantra Care Hub.
        </Text.paraSmall>
      </Layout.VStack>

      <Layout.VStack space={7} paddingTop={2}>
        {showTogetherall && (
          <TogetherAllCTACard
            key="togetherall-self-service-cta-card"
            headingLevel={incrementHeadingLevel(headingLevel)}
          />
        )}

        {showConnectNow && (
          <ConnectNowCTACard
            key="connect-now-self-service-cta-card"
            headingLevel={incrementHeadingLevel(headingLevel)}
          />
        )}

        {showSelfCare && (
          <SelfCareSelfServiceCTACard
            key="self-care-self-service-cta-card"
            headingLevel={incrementHeadingLevel(headingLevel)}
          />
        )}

        <SingleStopServiceCTACard key="single-stop-self-service-cta-card" />
      </Layout.VStack>
    </Layout.VStack>
  );
};
